<template>
  <div>

    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Coaches and Courses</el-breadcrumb-item>
      <el-breadcrumb-item>Coach Performance</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>


    <div class="filter-container">
      <label for="year-month">Please select the month:</label>
      <div class="year-month-select">
        <el-select v-model="selectedYearMonth" id="year-month" placeholder="Please select the month"
          @change="filterData">
          <el-option v-for="yearMonth in yearMonths" :key="yearMonth" :value="yearMonth"
            :label="formatYearMonth(yearMonth)"></el-option>
        </el-select>
      </div>

      <el-button type="primary" @click="viewData" style="margin-left: 20px;">View</el-button>

      <el-button type="primary" @click="exportCsv" style="margin-left: 80px;">Download CSV</el-button>
    </div>
    <div>
      <h3 style="text-align: left;">Coach Performance for {{ formatDate(this.$route.params.month) }}</h3>


      <el-table :data="tableData" stripe style="width: 100%; white-space:pre-wrap" height="750"    :default-sort="{prop: 'coach_perf', order: 'descending'}">

        <el-table-column prop="month" label="Month" width="120">
        </el-table-column>
        <el-table-column prop="coach_id" label="Coach ID" width="80">
        </el-table-column>

        <el-table-column prop="coach_name" label="Coach Name" width="110">
        </el-table-column>

        <el-table-column prop="course_count" label="New Courses"> </el-table-column>

        <el-table-column prop="course" label="Course List" width="300"> </el-table-column>

        <el-table-column prop="duration" label="Duration (min)" width="80"> </el-table-column>

        <el-table-column prop="user_count" label="Total Course Users" width="100">
        </el-table-column>
        <el-table-column prop="riding_count" label="Total Course Uses" width="100">
        </el-table-column>
        <el-table-column prop="avg_count" label="Average Uses" width="100">
        </el-table-column>

        <el-table-column prop="score" label="Total Score" width="100">
        </el-table-column>

        <el-table-column prop="avg_onbeat" label="Average Onbeat" width="100" sortable>
        </el-table-column>
        <el-table-column prop="avg_resistance" label="Average Resistance" sortable>
        </el-table-column>
        <el-table-column prop="score_per_min" label="Score Per Minute" sortable>
        </el-table-column>

        <el-table-column prop="completion_rate" label="Overall Completion Rate" sortable>
        </el-table-column>

        <el-table-column prop="coach_perf" label="Overall Coach Score" sortable>
          <template slot="header">
            <span>Overall Coach Score</span>
            <el-tooltip       :content="tooltipText" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>

      <el-dialog :visible.sync="dialogVisible" title="Tips">
        <p>{{ tooltipText }}</p>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import { exportToCsv } from '@/utils/exportToCsv';

export default {
  data() {
    return {
      selectedYearMonth: '',
      yearMonths: [], // 存储可选的年月列表
      tableData: [],// 存储表现状况的数组
      tooltipText: 'Comprehensive coach performance calculation rule: Average score per minute * 0.0015 + (Overall completion rate-0.70) * 100+ (Number of courses - 0, minimum 0) * 0.6+ Average course usage * 0.15',

      dialogVisible: false,
      data: [],// 准备下载的数组//
    };
  },
  created() {
    //console.log("created() ==>   完毕")
    this.initializeYearMonths();
    this.setDefaultSelectedYearMonth();

  },

  mounted() {
    // this.fetchDefaultData();
    let month = this.$route.params.month
    this.getData(month)

  },

  methods: {
    exportCsv() {
      let fileName = "coachPerf_" + this.$route.params.month
     // this.data= change this.tableData
         // el-table-column如下定义
    const columns = [
      { label: "Coach ID", prop: "coach_id" },
      { label: "Coach Name", prop: "coach_name" },
      { label: "New Courses", prop: "course_count" },
      { label: "Course List", prop: "course" },
      { label: "Duration (min)", prop: "duration" },
      { label: "Total Course Users", prop: "user_count" },
      { label: "Total Course Uses", prop: "riding_count" },
      { label: "Average Uses", prop: "avg_count" },
      { label: "Total Score", prop: "score" },
      { label: "Average Onbeat", prop: "avg_onbeat" },

      { label: "Average Resistance", prop: "avg_resistance" },
      { label: "Score Per Minute", prop: "score_per_min" },
      { label: "Overall Completion Rate", prop: "completion_rate" },
      { label: "Overall Coach Score", prop: "coach_perf" },

    ];
    
        
    // 首先对tableData按照coach_perf进行降序排序
    const sortedData = [...this.tableData].sort((a, b) => {
      return b.coach_perf - a.coach_perf; // 用于降序
    });

    // 转换数据，使用columns中定义的label作为字段名
    this.data = sortedData.map(row => {
      const rowData = {};
      columns.forEach(col => {
        rowData[col.label] = row[col.prop];
      });
      return rowData;
    });


      exportToCsv(this.data, fileName)
    },
    initializeYearMonths() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1; // JavaScript 中月份是从0开始的
      const yearMonths = [];
      for (let year = 2022; year <= currentYear; year++) {
        const startMonth = (year === 2022) ? 1 : 1; // Start from January
        const endMonth = (year === currentYear) ? currentMonth : 12; // Until the current month of the current year
        for (let month = startMonth; month <= endMonth; month++) {
          let monthKey = `${year}-${month.toString().padStart(2, '0')}`; // Formatting to YYYY-MM
          yearMonths.push(monthKey);
        }
      }
      this.yearMonths = yearMonths;
    },
    setDefaultSelectedYearMonth() {
      const currentDate = new Date();
      const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1); // Get the previous month
      const year = previousMonth.getFullYear();
      const month = (previousMonth.getMonth() + 1).toString().padStart(2, '0'); // Formatting to MM
      this.selectedYearMonth = `${year}-${month}`; // Formatting to YYYY-MM
    },
    formatDate(yearMonth) {
      const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const [year, month] = yearMonth.split('-');
      // 注意：月份是从0开始的，所以这里需要减1
      return `${months[parseInt(month, 10) - 1]} ${year}`;
    },
    filterData() {
      // 在这里可以添加筛选逻辑，根据选择的年月筛选数据
      //  先实现转移到url 中 
    },

    async getData(month) {

      const url = `da/coach_perf/${month}`;

      let res = await this.$http.get(url)

      this.tableData = res.data

    },
    viewData() {
      // 看看能否同步路由url 
      this.$router.push(`/coachPerf/${this.selectedYearMonth}`);

      // 在这里可以编写获取教练表现状况的逻辑
      // 可以通过发送请求或调用API来获取数据，并将数据存储在performances数组中
      // 示例代码：
      const url = `da/coach_perf/${this.$route.params.month}`;
      // 使用Axios或其他HTTP库发送请求，并处理返回的数据
      this.$http.get(url)
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },


    formatYearMonth(yearMonth) {
      // const [year, month] = yearMonth.split('-');
      //return `${year}年${month}月`;
      return yearMonth
    },

  }
};
</script>

<style scoped>
.filter-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.filter-container label {
  margin-right: 10px;
}

.year-month-select {
  width: 140px;
}
</style>